<!--
  * name: SnsShare
  * description: 페이지 공유하기 컴포넌트
-->
<template>
    <div>
        <!-- <button class="detail-top-style-sns kakao" id="shareKaKaoBtn" type="button">카카오톡으로 공유</button> -->
        <button class="detail-top-style-sns facebook" id="shareFacebookBtn" type="button" @click="setShareForFacebook">페이스북으로 공유</button>
        <button class="detail-top-style-sns twitter" id="shareTwitterBtn" type="button" @click="setShareForTwitter">트위터로 공유</button>
        <button class="detail-top-style-sns band" id="shareBandBtn" type="button" @click="setShareForBand">밴드로 공유</button>
        <button class="detail-top-style-sns linkCopy" type="button" @click="copyUri">링크 복사</button>
    </div>
</template>
<script>
import { BrowserPopup } from '@/utils/common';

export default {
  name: 'SnsShare',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      shareUrl: document.location.href,
    };
  },
  mounted() {
    // this.setShareForKakao();
    // this.setShareForBand();
  },
  methods: {
    // ## 카카오톡 공유하기 셋팅
    setShareForKakao() {
      window.Kakao.Link.createDefaultButton({
        container: '#shareKaKaoBtn',
        objectType: 'feed',
        content: {
          title: this.title,
          description: this.description,
          imageUrl:
        'http://k.kakaocdn.net/dn/Q2iNx/btqgeRgV54P/VLdBs9cvyn8BJXB3o7N8UK/kakaolink40_original.png',
          link: {
            mobileWebUrl: this.shareUrl,
            webUrl: this.shareUrl,
          },
        },
        buttons: [
          {
            title: '웹으로 보기',
            link: {
              mobileWebUrl: this.shareUrl,
              webUrl: this.shareUrl,
            },
          },
        ],
      });
    },
    setShareForBand() {
      const content = encodeURIComponent(`${this.title}\n`) + this.shareUrl;
      BrowserPopup(`http://www.band.us/plugin/share?body=${content}&route=${this.shareUrl}`, 410, 540);
    },
    setShareForFacebook() {
      const content = encodeURIComponent(`${this.title}\n`);
      BrowserPopup(`http://www.facebook.com/sharer.php?u=${encodeURIComponent(this.shareUrl)}&t=${content}`, 400, 400);
    },
    setShareForTwitter() {
      const content = encodeURIComponent(`${this.title}\n`);
      BrowserPopup(`http://twitter.com/intent/tweet?url=${encodeURIComponent(this.shareUrl)}&text=${content}`, 400, 400);
    },
    copyUri() {
      const tempElement = document.createElement('textarea');
      document.body.appendChild(tempElement);
      tempElement.value = this.shareUrl;
      tempElement.select();
      document.execCommand('copy');
      document.body.removeChild(tempElement);
      // eslint-disable-next-line no-alert
      alert('주소가 복사되었습니다.');
    },
  },
};
</script>
